module.exports = __webpack_public_path__ + "img/star_04.de29e5dc.png";